import styled  from 'styled-components';

const Warning = styled.p`
    color: red;
`

export default Warning; 